@if (!reload) {
    <div>
        <h3 data-bb="header">{{ 'mijn.overzicht.template.sendableOrdersModal.header' | apContent }}</h3>
        <p data-bb="paragraph" class="ap-margin-bottom-8 ap-display-block">
            {{ 'mijn.overzicht.template.sendableOrdersModal.paragraph' | apContent }}
        </p>
        <ap-button (onClick)="onLogout()" data-bb="logout">
            {{ 'mijn.overzicht.template.sendableOrdersModal.logout' | apContent }}
        </ap-button>
        <ap-button (onClick)="toVerzendlijst()" data-bb="toVerzendlijst" [variant]="'secondary'">
            {{ 'mijn.overzicht.template.sendableOrdersModal.toVerzendlijst' | apContent }}
        </ap-button>
    </div>
}
